import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { VoucherInfo } from "./VoucherInfo.jsx";
import { api } from "~/lib/api.js";
import { DisconnectOutlined } from "@ant-design/icons";
import { $t } from "~/i18n.js";
import { Popconfirm } from "antd";

export function VoucherModal({
  open,
  voucher,
  onClose,
  fetchRemainingData,
  disconnectVoucher,
  readOnly
}) {

  const [loading, setLoading] = useState(true);
  const [disconnecting, setDisconnecting] = useState(false);
  const [openVoucher, setOpenVoucher] = useState(null);

  const getData = async () => {
    const data = await api.get(`financial/vouchers/${voucher.id}/data.json`);
    setOpenVoucher(data);
    setLoading(false);
  };

  const handleDisconnect = async () => {
    setDisconnecting(true);
    disconnectVoucher(voucher.id);
    onClose();
    setDisconnecting(false);
  };

  useEffect(() => {
    setLoading(true);
    if (open && voucher && fetchRemainingData) {
      getData();
    } else {
      setOpenVoucher(voucher);
      setLoading(false);
    }
  }, [open, voucher, fetchRemainingData]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={onClose}
      loading={loading}
      title={voucher?.name || "Voucher"}
      width={400}
      footer={
        disconnectVoucher ? (
          <Popconfirm
            key="remove"
            placement="bottom"
            title={$t("Zeker weten?")}
            onConfirm={handleDisconnect}
            okText={$t("Ja")}
            cancelText={$t("Nee")}
          >
            <Button
              danger
              loading={disconnecting}
              block
              disabled={readOnly}
              icon={<DisconnectOutlined />}
            >
              {$t("Ontkoppel bon")}
            </Button>
          </Popconfirm>
        ) : null
      }
    >
      {openVoucher && <VoucherInfo voucher={openVoucher} />}
    </Modal>
  );
}
